import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { currentBasketItemByIdAtom, BasketItem } from '../basket/state/state';

export default function useBasketItem(id: string): BasketItem | undefined {
  const itemBasketAtom = useMemo(() => currentBasketItemByIdAtom(id), [id]);

  return useAtomValue(itemBasketAtom);
}
